var map = {
	"./01.svg": "t6R2",
	"./02.svg": "ql1P",
	"./03.svg": "9+Jf",
	"./04.svg": "QrSj",
	"./Treatment-Dr.svg": "E5Bw",
	"./awards.svg": "uJvM",
	"./braces.svg": "esvK",
	"./consultation-old.svg": "w+JQ",
	"./consultation.svg": "mY39",
	"./education.svg": "Xnxo",
	"./facebook.svg": "85DX",
	"./family.svg": "2+5z",
	"./financial.svg": "QG8Q",
	"./financing-old.svg": "+gKG",
	"./financing.svg": "azWI",
	"./footer-bg.svg": "WihP",
	"./footer-logo.svg": "ShFT",
	"./form-1.svg": "SISf",
	"./form-2.svg": "00Oo",
	"./form-3.svg": "WNiS",
	"./hills.svg": "4fZB",
	"./insta.svg": "L+fD",
	"./instagram.svg": "OCqi",
	"./left.svg": "XtuF",
	"./location.svg": "UqX2",
	"./logo-1.svg": "zhRq",
	"./logo-2.svg": "rUyX",
	"./logo-frog.svg": "uWpV",
	"./logo.svg": "EFw+",
	"./phase-icon.svg": "lT+5",
	"./phone.svg": "9pTP",
	"./quote--left.svg": "VMcO",
	"./quote--right.svg": "bpPH",
	"./right.svg": "4hpK",
	"./smile-old.svg": "o/jX",
	"./smile.svg": "DlCd",
	"./tooth.svg": "//ZY",
	"./twitter.svg": "lS6+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 0